<template lang='pug'>
  .center-selected-nav
    touch.nav-inner(ref="navInner" @left="swipeLeft" @right="swipeRight" :style="{width: totalWidth + 'px'}")
      template(v-for="(label, index) in labels")
        button.btn-reset.upper.color-slate.xs-f-small.max-at-tweak(type="button" :key="label" @click="update(index)" :class="{ selected: value == index }")
          span(tabindex="-1") {{ label }}
</template>

<script>
  import touch from './touch';

  export default {
    name: "CenterSelectedNav",

    props: {
      labels: {
        type: Array
      },
      value: {
        type: Number
      }
    },

    data() {
      return {
        isMounted: false,
        totalWidth: 0
      }
    },

    methods: {
      update(val) {
        this.centerSelected(val);
        this.$emit('input', val);
      },

      swipeLeft() {
        this.$emit('swipeLeft');
      },

      swipeRight() {
        this.$emit('swipeRight');
      },

      getTotalWidth() {
        if (!this.isMounted) {
          return 0;
        }
        var totalWidth = 0;
        
        for (var x = 0; x < this.$refs['navInner'].$el.children.length; x++) {
          totalWidth += $(this.$refs['navInner'].$el.children[x]).outerWidth();
        }

        totalWidth = Math.ceil(totalWidth + 1);
        
        this.totalWidth = totalWidth;
        
        return totalWidth;
      },

      centerSelected(index) {
        var outerElement = $(this.$el);
        var innerElement = $(this.$refs['navInner'].$el);
        var outerWidth = outerElement.outerWidth();
        var innerWidth = innerElement.outerWidth();

        if (innerWidth > outerWidth) {
          var offset = 0;
          var innerChildren = innerElement[0].children;

          for (var x = 0; x < index; x++) {
            offset += $(innerChildren[x]).outerWidth();
          }

          offset = offset + ($(innerChildren[index]).outerWidth() / 2);
          offset = offset * -1;
          offset = offset + (outerWidth / 2);

          innerElement.css('margin', '0 0 0 ' + Math.ceil(offset) + 'px');
        } else {
          innerElement.css('margin', '0 auto');
        }
      },

      onResize() {
        this.getTotalWidth();
        // timeout prevents centerSelected from being called before totalWidth is set
        setTimeout(() => {
          this.centerSelected(this.value);
        }, 10);
      }
    },

    mounted() {
      this.isMounted = true;
      this.onResize();
      window.addEventListener('resize', this.onResize);
    },

    destroyed() {
      window.removeEventListener('resize', this.onResize);
    }
  }
</script>

<style scoped lang="stylus">
  .center-selected-nav
    width 100%
    background-color color-fog-mist
    border 1px solid color-fog-light
    border-left none
    border-right none
    
    .nav-inner
      white-space nowrap
      transition(margin 400ms ease-in-out)
      
      button
        position relative

        span
          padding 1.25em
          display inline-block

          &:focus
            outline none
        
        &.selected
          color color-mr-purple
          font-family font-family-primary-bold
          
          &:before
          &:after
            content ''
            width 0
            height 0
            border 1.25em solid transparent
            border-top-width 1em
            border-bottom-width 1em
            border-bottom-color color-fog-light
            position absolute
            left 50%
            margin-left -1.25em
            bottom 0
            
          &:after
            bottom -2px
            border-bottom-color color-white
            z-index 10
      
</style>
